<script>
	import { Button, Col, Row } from "sveltestrap";
	import PageHeader from "../../../../components/PageHeader/PageHeader.svelte";
	import { form, field, combined } from "svelte-forms";
	import { navigate } from "svelte-routing";
	import {
		errorMessage,
		loading,
		totalPages,
		loadingStatus,
		vehicleEditData,
	} from "../../../../store/store";
	import client from "../../../../services/client";
	import Loader from "../../../../components/Loader/Loader.svelte";
	import { required } from "svelte-forms/validators";
	import CustomInput from "../../../../components/CustomInput/CustomInput.svelte";

	let idAssetOwner = window.location.pathname.split(
		"master-data/vehicle-data/vehicle-asset-owner/edit/"
	)[1];
	let data = [];
	let carAssetOwnerError;
	const carAssetOwner = field("carAssetOwner", $vehicleEditData.name, [
		required(),
	]);
	const myForm = form(carAssetOwner);

	let load = false;
	const handleSubmit = async () => {
		try {
			load = true;
			loading.set(true);
			const res = await client("/v1/carAssetOwners", {
				method: "PUT",
				version: "Vehicle",
				data: {
					name: $carAssetOwner.value,
					id: idAssetOwner,
				},
			});

			if (res.status === 200) {
				navigate("/master-data/vehicle-data/vehicle-asset-owner");
			} else {
				loading.set(false);
				carAssetOwnerError = res.data.message;
			}

			load = false;
			loading.set(false);
		} catch (error) {
			console.log(error);
			load = false;
			carAssetOwnerError = error.response.data.message;
			loading.set(false);
		}
	};
</script>

<Row>
	<Col xs={6}>
		<Col xs={12}>
			<div>
				<Col className="row d-flex align-items-start mx-0">
					<PageHeader title="Vehicle Asset Owner Data" />
				</Col>
			</div>
		</Col>
		<Col xs={12} class="my-3">
			<div>
				<h5><b>Edit Asset Owner Name</b></h5>
			</div>
			<div>
				<p>*Mandatory fields</p>
			</div>
		</Col>
		<Col>
			<Row>
				<Col>
					<label for="mobile" class="d-block">
						<span>Asset owner Name* </span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col xs={6}>
					<CustomInput
						type="text"
						bind:value={$carAssetOwner.value}
						error={$myForm.hasError("carAssetOwner.required") ||
							carAssetOwnerError}
						errorText={$myForm.hasError("carAssetOwner.required")
							? "Asset owner name is required"
							: carAssetOwnerError
							? carAssetOwnerError
							: ""}
					/>
				</Col>
				<Col class="d-flex justify-content-start" xs={6}>
					<div class="mx-4 my-1">
						<Button
							class="themeButton primary px-2"
							block
							disabled={!$myForm.valid || !$carAssetOwner.value}
							on:click={myForm.validate}
							on:click={() => handleSubmit()}
						>
							{#if load}
								<Loader />
							{:else}
								Edit
							{/if}
						</Button>
					</div>
				</Col>
			</Row>
		</Col>
	</Col>
</Row>
